module.exports = "/assets/d8da00c99179a116f39e1cd2f21d162a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IA.png
// module id = 1467
// module chunks = 0